export function PrivacyContent() {
  return (
    <div className="legal-document text-sm text-brand-text leading-relaxed space-y-6">

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          1. Introdução e Identificação do Controlador
        </h2>
        <p className="mb-3">
          Esta Política de Privacidade descreve como o RegenerAI coleta, usa, armazena e protege
          os dados pessoais dos seus usuários, em conformidade com a Lei Geral de Proteção de
          Dados (LGPD — Lei nº 13.709/2018).
        </p>
        <p>
          <strong>Controlador de dados:</strong> RegenerAI (GAAS — Grupo de Agricultores para
          a Agricultura Sustentável), São Paulo/SP, Brasil.
          Contato: dpo@regenerai.ag
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          2. Dados Coletados
        </h2>
        <h3 className="font-semibold mb-2">2.1. Dados de Cadastro</h3>
        <p className="mb-3">
          Ao criar uma conta, coletamos: nome completo, endereço de e-mail, CPF (necessário para
          verificação de identidade e prevenção de fraudes), nome de usuário, telefone/WhatsApp
          (opcional), cidade, estado, profissão e perfil de uso (produtor, técnico, pesquisador
          etc.).
        </p>
        <p className="mb-3">
          <strong>CPF:</strong> o CPF é coletado com base na execução do contrato (LGPD art. 7,
          V) e na prevenção de fraudes (art. 7, II). Não o compartilhamos com terceiros para
          fins comerciais e o armazenamos com criptografia. Após a exclusão da conta, mantemos
          apenas um hash irreversível do CPF para impedir a criação de novas contas com o mesmo
          documento, em cumprimento ao art. 16 da LGPD.
        </p>
        <h3 className="font-semibold mb-2">2.2. Dados de Uso</h3>
        <p className="mb-3">
          Durante o uso da plataforma, registramos: histórico de conversas com o assistente de
          IA, documentos e arquivos enviados para análise, preferências e configurações,
          metadados de acesso (data, hora, dispositivo, endereço IP).
        </p>
        <h3 className="font-semibold mb-2">2.3. Dados de Consentimento</h3>
        <p>
          Registramos a aceitação destes termos com data, hora e endereço IP de origem, conforme
          exigido pela LGPD para comprovação do consentimento (art. 7, I).
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          3. Finalidades e Bases Legais
        </h2>
        <p className="mb-3">Utilizamos seus dados para as seguintes finalidades:</p>
        <ul className="list-disc list-outside ml-5 space-y-3">
          <li>
            <strong>Prestação do serviço</strong> — fornecer o assistente de IA, marketplace e
            conteúdo educativo.<br />
            <em>Base legal: execução de contrato (art. 7, V).</em>
          </li>
          <li>
            <strong>Personalização</strong> — adaptar as respostas da IA ao seu contexto
            específico (bioma, sistema de produção, perfil profissional).<br />
            <em>Base legal: execução de contrato (art. 7, V) e consentimento (art. 7, I).</em>
          </li>
          <li>
            <strong>Melhoria contínua</strong> — aprimorar nossos modelos com dados
            anonimizados.<br />
            <em>Base legal: interesse legítimo (art. 7, IX), com anonimização prévia.</em>
          </li>
          <li>
            <strong>Comunicação e suporte</strong> — enviar atualizações, novidades e suporte
            técnico.<br />
            <em>Base legal: consentimento (art. 7, I).</em>
          </li>
          <li>
            <strong>Segurança e prevenção de fraudes</strong> — proteger a integridade da
            plataforma.<br />
            <em>Base legal: cumprimento de obrigação legal (art. 7, II).</em>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          4. Compartilhamento de Dados
        </h2>
        <p className="mb-3">
          <strong>Não vendemos, alugamos nem comercializamos seus dados pessoais.</strong>
        </p>
        <p className="mb-3">Compartilhamentos realizados apenas nos seguintes casos:</p>
        <ul className="list-disc list-outside ml-5 space-y-2">
          <li>
            <strong>Parceiros de serviço essenciais</strong> (hospedagem AWS, e-mail transacional)
            — apenas com o estritamente necessário e sob contrato de confidencialidade;
          </li>
          <li>
            <strong>Dados anonimizados para pesquisa</strong> — sem qualquer identificador
            pessoal, para estudos em agricultura regenerativa com instituições parceiras;
          </li>
          <li>
            <strong>Obrigação legal</strong> — quando exigido por lei, ordem judicial ou
            requisição de autoridade competente, após verificação legal.
          </li>
        </ul>
        <p className="mt-3">
          Os dados são armazenados em servidores AWS localizados no Brasil. Transferências
          internacionais, quando necessárias, seguem salvaguardas adequadas nos termos da LGPD.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          5. Direitos do Titular (LGPD)
        </h2>
        <p className="mb-3">
          Você tem controle total sobre seus dados. Nos termos da LGPD, garantimos os seguintes
          direitos:
        </p>
        <ul className="list-disc list-outside ml-5 space-y-3">
          <li>
            <strong>Acesso e informação</strong> — saber quais dados mantemos e como os
            utilizamos.<br />
            <em>Como exercer: e-mail para dpo@regenerai.ag — resposta em até 15 dias corridos.</em>
          </li>
          <li>
            <strong>Correção e atualização</strong> — corrigir dados incorretos ou
            desatualizados.<br />
            <em>Como exercer: pelo perfil do usuário em Configurações ou via e-mail.</em>
          </li>
          <li>
            <strong>Exclusão (direito ao esquecimento)</strong> — solicitar a exclusão de seus
            dados pessoais.<br />
            <em>
              Como exercer: <strong>self-service</strong> em Configurações → Segurança →
              "Excluir minha conta" (efeito imediato); ou via e-mail para dpo@regenerai.ag
              (prazo de até 30 dias).
            </em>
          </li>
          <li>
            <strong>Portabilidade</strong> — receber seus dados em formato estruturado
            (JSON/CSV).<br />
            <em>Como exercer: solicitação via e-mail — prazo de até 30 dias.</em>
          </li>
          <li>
            <strong>Revogação de consentimento</strong> — retirar o consentimento a qualquer
            momento.<br />
            <em>Como exercer: Configurações → Segurança ou e-mail para dpo@regenerai.ag.</em>
          </li>
          <li>
            <strong>Revisão de decisões automatizadas</strong> — solicitar revisão humana de
            decisões baseadas exclusivamente em IA.<br />
            <em>Como exercer: e-mail para dpo@regenerai.ag.</em>
          </li>
        </ul>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          6. Segurança e Proteção
        </h2>
        <h3 className="font-semibold mb-2">6.1. Medidas Técnicas</h3>
        <ul className="list-disc list-outside ml-5 space-y-2 mb-4">
          <li>TLS 1.3 em todas as conexões (HTTPS);</li>
          <li>criptografia de senhas com hashing seguro e salt;</li>
          <li>controle de acesso baseado em funções (RBAC);</li>
          <li>infraestrutura AWS com certificações ISO 27001 e SOC 2;</li>
          <li>backups automáticos criptografados;</li>
          <li>monitoramento contínuo de segurança.</li>
        </ul>
        <h3 className="font-semibold mb-2">6.2. Resposta a Incidentes</h3>
        <p>
          Em caso de violação de dados com risco aos titulares, notificaremos a ANPD em até
          72 horas e os usuários afetados imediatamente, conforme LGPD art. 48. Para reportar
          incidentes: dpo@regenerai.ag.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          7. Retenção e Eliminação de Dados
        </h2>
        <h3 className="font-semibold mb-2">7.1. Prazos de Retenção</h3>
        <ul className="list-disc list-outside ml-5 space-y-2 mb-4">
          <li>
            <strong>Conta ativa:</strong> dados mantidos enquanto a conta estiver ativa e o
            serviço for utilizado.
          </li>
          <li>
            <strong>Após solicitação de exclusão pelo usuário:</strong> conversas e dados de
            interação são excluídos de forma definitiva em até 90 dias.
          </li>
          <li>
            <strong>Inatividade:</strong> contas sem acesso por período superior a 730 dias
            (2 anos) têm as conversas excluídas automaticamente, com notificação prévia.
          </li>
          <li>
            <strong>Dados legais obrigatórios:</strong> informações fiscais e registros
            exigidos por lei podem ser retidos pelo prazo legal aplicável.
          </li>
          <li>
            <strong>Dados anonimizados:</strong> dados completamente anonimizados (sem
            identificação pessoal) podem ser retidos indefinidamente para fins de pesquisa.
          </li>
        </ul>
        <h3 className="font-semibold mb-2">7.2. Processo de Eliminação</h3>
        <p>
          A eliminação é feita de forma segura, com remoção dos dados dos sistemas ativos e
          backups dentro dos prazos aplicáveis. Um registro de auditoria da eliminação é mantido,
          conforme exigido pela LGPD.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          8. Cookies e Tecnologias Similares
        </h2>
        <p className="mb-3">
          Utilizamos cookies essenciais para o funcionamento da plataforma (autenticação, segurança
          e preferências básicas). Esses cookies não podem ser desativados sem prejudicar o
          funcionamento do serviço.
        </p>
        <p className="mb-3">
          Cookies analíticos (Google Analytics anonimizado) e de funcionalidade (tema, idioma) são
          opcionais e requerem consentimento explícito.
        </p>
        <p>
          <strong>Não utilizamos</strong> rastreamento cruzado entre sites, fingerprinting de
          dispositivo, cookies de terceiros para publicidade nem gravação de telas ou teclado.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          9. Proteção de Menores
        </h2>
        <p className="mb-3">
          O RegenerAI não se destina a menores de 18 anos e não coleta intencionalmente dados
          de crianças ou adolescentes. Caso identifiquemos o cadastro de menor de idade, os dados
          serão removidos imediatamente.
        </p>
        <p>
          Pais ou responsáveis que identificarem uso indevido por menor devem contatar
          dpo@regenerai.ag com o assunto "Menor de idade — Remoção urgente".
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          10. Contato do Encarregado (DPO)
        </h2>
        <p className="mb-3">
          Nosso Encarregado de Proteção de Dados (DPO) é o ponto de contato dedicado para todas
          as questões relacionadas a privacidade e direitos LGPD.
        </p>
        <ul className="list-none space-y-2 mb-3">
          <li><strong>E-mail:</strong> dpo@regenerai.ag</li>
          <li><strong>Prazo de resposta:</strong> até 15 dias corridos (LGPD)</li>
          <li><strong>Endereço:</strong> São Paulo/SP — Brasil</li>
        </ul>
        <p className="mb-3">
          Para exercer seus direitos, informe: nome completo, CPF (para verificação), e-mail
          cadastrado na plataforma e descrição detalhada da solicitação.
        </p>
        <p>
          <strong>Autoridade Nacional:</strong> caso não esteja satisfeito com nossa resposta,
          você pode apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD) em
          gov.br/anpd.
        </p>
      </section>

      <section>
        <h2 className="text-base font-bold text-brand-text mb-3 pb-1 border-b border-brand-border">
          11. Atualizações desta Política
        </h2>
        <p className="mb-3">
          Esta política pode ser atualizada para refletir mudanças em nossas práticas, na
          legislação aplicável ou em novos serviços. Mudanças significativas serão comunicadas
          com 30 dias de antecedência por e-mail.
        </p>
        <ul className="list-none space-y-1">
          <li><strong>Versão 1.0</strong> — 23 de março de 2026: política inicial.</li>
          <li><strong>Versão 1.1</strong> — 14 de abril de 2026: inclusão de exclusão de conta
          self-service e ajuste dos prazos de retenção.</li>
        </ul>
      </section>

    </div>
  )
}
